const ROUTE_KEY = {
  DAILY_REBBE_VIDEO: "daily-rebbe-video",
  ILLUMINATE: "illuminate",
  MY_MAOR: "my-maor",
};

export default ROUTE_KEY;
